import { render, staticRenderFns } from "./PageViewPackageGroups.vue?vue&type=template&id=8c464daa&"
import script from "./PageViewPackageGroups.vue?vue&type=script&lang=ts&"
export * from "./PageViewPackageGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports